import api from './api';

export function getActivities() {
  return api.get(`${process.env.REACT_APP_INSTANCE}${process.env.REACT_APP_ENVIROMENT}onboardingservices/actividades-economicas`);
}

export function getActivitiesPorIdPagaduria(idPagaduria) {
  return api.get(`${process.env.REACT_APP_INSTANCE}${process.env.REACT_APP_ENVIROMENT}onboardingservices/actividadeseconomicas/${idPagaduria}/pagaduria`);
}
